import { Box, Icon } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { iArrowUp } from '@hover/icons';

interface Props {
  distance: number;
  showButton: boolean;
  setShowButton: React.Dispatch<boolean>;
}

const BackToTopButton: React.FC<Props> = ({
  distance,
  showButton,
  setShowButton,
}) => {
  const [scrolling, setIsScrolling] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('scroll', () => {
      if (
        document.body.scrollTop > distance ||
        document.documentElement.scrollTop > distance
      ) {
        setShowButton(true);
      } else {
        setShowButton(false);
        setIsScrolling(false);
      }
    });
  }, []);

  const backToTop = () => {
    if (window) {
      setIsScrolling(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <Box
      w={300}
      h={300}
      borderRadius="50%"
      alignItems="center"
      justifyContent="center"
      bg={!scrolling ? 'primary.600' : 'primary.100'}
      position="fixed"
      bottom="32px"
      right="32px"
      d={{ base: showButton ? 'block' : 'none', tablet: 'none' }}
    >
      <Icon
        size="default"
        icon={iArrowUp}
        color={scrolling ? 'brandNavy.500' : 'neutral.0'}
        onClick={backToTop}
      />
    </Box>
  );
};

export default BackToTopButton;
